(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["built-home"] && !Shopify.designMode) return;
  try {
    
(function () {
  function initVirevaProductMarquee() {
    document.querySelectorAll('[data-product-slider]').forEach(function (slider) {
      if (slider.dataset.autoplayReady === 'true') return;
      slider.dataset.autoplayReady = 'true';

      var originals = Array.from(slider.children);
      if (originals.length < 2) return;

      originals.forEach(function (item) {
        var clone = item.cloneNode(true);
        clone.setAttribute('aria-hidden', 'true');
        slider.appendChild(clone);
      });

      var paused = false;
      var last = performance.now();
      var speed = 34;

      function originalWidth() {
        return slider.scrollWidth / 2;
      }

      function frame(now) {
        var dt = Math.min(now - last, 50);
        last = now;

        if (!paused && !document.hidden) {
          slider.scrollLeft += speed * dt / 1000;
          var width = originalWidth();
          if (width > 0 && slider.scrollLeft >= width) {
            slider.scrollLeft -= width;
          }
        }
        requestAnimationFrame(frame);
      }

      slider.addEventListener('mouseenter', function () { paused = true; });
      slider.addEventListener('mouseleave', function () { paused = false; });
      slider.addEventListener('focusin', function () { paused = true; });
      slider.addEventListener('focusout', function () { paused = false; });
      slider.addEventListener('touchstart', function () { paused = true; }, { passive: true });
      slider.addEventListener('touchend', function () {
        setTimeout(function () { paused = false; }, 1200);
      }, { passive: true });

      requestAnimationFrame(frame);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initVirevaProductMarquee);
  } else {
    initVirevaProductMarquee();
  }
})();

(function(){
  var buttons=Array.from(document.querySelectorAll('.vr-actions .hero-business'));
  var paint=[
    ['#ff00d4','-82%','-8%','1.65','1.05','-18deg','3.55s','0s'],
    ['#00eaff','84%','-18%','1.5','1.18','22deg','3.85s','.04s'],
    ['#7a00ff','-46%','72%','1.38','1.55','14deg','4.05s','.08s'],
    ['#ff6a00','58%','76%','1.5','1.42','-24deg','3.75s','.02s'],
    ['#dfff00','-10%','-86%','1.3','1.6','10deg','3.95s','.1s'],
    ['#00ffb7','18%','88%','1.42','1.5','-12deg','4.1s','.06s'],
    ['#ff0055','92%','30%','1.58','1.22','26deg','3.7s','.12s']
  ];
  buttons.forEach(function(el,i){
    el.classList.add('vr-neon-fx','vr-fx-'+((i%6)+1));
    el.style.setProperty('--vr-base-bg',getComputedStyle(el).background);
    if(el.dataset.vrStartupReady!=='true'){
      el.dataset.vrStartupReady='true';
      var content=document.createElement('span');
      content.className='vr-neon-content';
      while(el.firstChild) content.appendChild(el.firstChild);
      var stage=document.createElement('span');
      stage.className='vr-startup-stage';
      stage.setAttribute('aria-hidden','true');
      paint.forEach(function(p,n){
        var blob=document.createElement('span');
        blob.className='vr-startup-blob vr-startup-'+(n+1);
        blob.setAttribute('aria-hidden','true');
        blob.style.setProperty('--paint',p[0]);
        blob.style.setProperty('--tx',p[1]);
        blob.style.setProperty('--ty',p[2]);
        blob.style.setProperty('--sx',p[3]);
        blob.style.setProperty('--sy',p[4]);
        blob.style.setProperty('--rot',p[5]);
        blob.style.setProperty('--dur',p[6]);
        blob.style.setProperty('--delay',p[7]);
        stage.appendChild(blob);
      });
      var core=document.createElement('span');
      core.className='vr-startup-core';
      core.setAttribute('aria-hidden','true');
      stage.appendChild(core);
      el.appendChild(stage);
      el.appendChild(content);
    }
  });
  var timers=new WeakMap();
  var observer=new IntersectionObserver(function(entries){
    entries.forEach(function(entry){
      var el=entry.target;
      if(entry.intersectionRatio>=.28){
        if(el.dataset.vrVisible==='true') return;
        el.dataset.vrVisible='true';
        var index=buttons.indexOf(el);
        var scheduled=[];
        var startTimer=setTimeout(function(){
          if(el.dataset.vrVisible!=='true') return;
          el.classList.remove('is-active','is-crossfade','is-handoff','is-handoff-ready');
          el.classList.add('is-entering');

          var activeTimer=setTimeout(function(){
            if(el.dataset.vrVisible!=='true') return;
            el.classList.add('is-active','is-crossfade');
          },3400);

          var finishTimer=setTimeout(function(){
            if(el.dataset.vrVisible!=='true') return;
            el.classList.remove('is-entering','is-crossfade');
          },4300);

          scheduled.push(activeTimer,finishTimer);
          timers.set(el,scheduled);
        },420+((index%3)*140));
        scheduled.push(startTimer);
        timers.set(el,scheduled);
      }else if(!entry.isIntersecting){
        el.dataset.vrVisible='false';
        var scheduled=timers.get(el)||[];
        scheduled.forEach(function(t){clearTimeout(t);});
        timers.delete(el);
        el.classList.remove('is-entering','is-active','is-crossfade','is-handoff','is-handoff-ready');
      }
    });
  },{threshold:[0,.28],rootMargin:'0px 0px -6% 0px'});
  buttons.forEach(function(el){observer.observe(el);});
})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vireva-custom-product"]) return;
  try {
    
(function(){
  function initCustomPreview(){
    var input=document.getElementById('vcp-file');
    var img=document.getElementById('vcp-poster-preview');
    var placeholder=document.getElementById('vcp-poster-placeholder');
    if(!input||!img) return;
    input.addEventListener('change',function(){
      var file=input.files&&input.files[0];
      if(!file) return;
      var reader=new FileReader();
      reader.onload=function(e){
        img.src=e.target.result;
        img.style.display='block';
        if(placeholder) placeholder.style.display='none';
      };
      reader.readAsDataURL(file);
    });
  }
  if(document.readyState==='loading'){
    document.addEventListener('DOMContentLoaded',initCustomPreview);
  }else{
    initCustomPreview();
  }
})();

(function(){
  var buttons=Array.from(document.querySelectorAll('.vcp-upload-btn,.vcp-add'));
  var paint=[
    ['#ff00d4','-82%','-8%','1.65','1.05','-18deg','3.55s','0s'],
    ['#00eaff','84%','-18%','1.5','1.18','22deg','3.85s','.04s'],
    ['#7a00ff','-46%','72%','1.38','1.55','14deg','4.05s','.08s'],
    ['#ff6a00','58%','76%','1.5','1.42','-24deg','3.75s','.02s'],
    ['#dfff00','-10%','-86%','1.3','1.6','10deg','3.95s','.1s'],
    ['#00ffb7','18%','88%','1.42','1.5','-12deg','4.1s','.06s'],
    ['#ff0055','92%','30%','1.58','1.22','26deg','3.7s','.12s']
  ];
  buttons.forEach(function(el,i){
    el.classList.add('vr-neon-fx','vr-fx-'+((i%6)+1));
    el.style.setProperty('--vr-base-bg',getComputedStyle(el).background);
    if(el.dataset.vrStartupReady!=='true'){
      el.dataset.vrStartupReady='true';
      var content=document.createElement('span');
      content.className='vr-neon-content';
      while(el.firstChild) content.appendChild(el.firstChild);
      var stage=document.createElement('span');
      stage.className='vr-startup-stage';
      stage.setAttribute('aria-hidden','true');
      paint.forEach(function(p,n){
        var blob=document.createElement('span');
        blob.className='vr-startup-blob vr-startup-'+(n+1);
        blob.setAttribute('aria-hidden','true');
        blob.style.setProperty('--paint',p[0]);
        blob.style.setProperty('--tx',p[1]);
        blob.style.setProperty('--ty',p[2]);
        blob.style.setProperty('--sx',p[3]);
        blob.style.setProperty('--sy',p[4]);
        blob.style.setProperty('--rot',p[5]);
        blob.style.setProperty('--dur',p[6]);
        blob.style.setProperty('--delay',p[7]);
        stage.appendChild(blob);
      });
      var core=document.createElement('span');
      core.className='vr-startup-core';
      core.setAttribute('aria-hidden','true');
      stage.appendChild(core);
      el.appendChild(stage);
      el.appendChild(content);
    }
  });
  var timers=new WeakMap();
  var observer=new IntersectionObserver(function(entries){
    entries.forEach(function(entry){
      var el=entry.target;
      if(entry.intersectionRatio>=.28){
        if(el.dataset.vrVisible==='true') return;
        el.dataset.vrVisible='true';
        var index=buttons.indexOf(el);
        var scheduled=[];
        var startTimer=setTimeout(function(){
          if(el.dataset.vrVisible!=='true') return;
          el.classList.remove('is-active','is-crossfade','is-handoff','is-handoff-ready');
          el.classList.add('is-entering');

          var activeTimer=setTimeout(function(){
            if(el.dataset.vrVisible!=='true') return;
            el.classList.add('is-active','is-crossfade');
          },3400);

          var finishTimer=setTimeout(function(){
            if(el.dataset.vrVisible!=='true') return;
            el.classList.remove('is-entering','is-crossfade');
          },4300);

          scheduled.push(activeTimer,finishTimer);
          timers.set(el,scheduled);
        },440+((index%2)*150));
        scheduled.push(startTimer);
        timers.set(el,scheduled);
      }else if(!entry.isIntersecting){
        el.dataset.vrVisible='false';
        var scheduled=timers.get(el)||[];
        scheduled.forEach(function(t){clearTimeout(t);});
        timers.delete(el);
        el.classList.remove('is-entering','is-active','is-crossfade','is-handoff','is-handoff-ready');
      }
    });
  },{threshold:[0,.28],rootMargin:'0px 0px -6% 0px'});
  buttons.forEach(function(el){observer.observe(el);});
})();


  } catch(e) { console.error(e); }
})();
})();
